
    import { Component, Prop,Watch,Model } from "vue-property-decorator";
    import { BaseVue } from "@newview/base-web";
    import { DistinctareaApi } from "@newview/system-api";
    @Component({
        name: "NSelect",
        components: {
        },
    })
    export default class NSelect extends BaseVue {
        @Prop({ default: () => "tag" }) tag!: string; //唯一标识（表单组件中使用，有多个区域选择组件时，通过tag区分）
        @Prop({ default: () => null }) actionApi!: any; //接口Api 控制器
        @Prop({ default: () => false }) readonly!: boolean; //是否只读
        @Prop({ default: () => false }) zj!: boolean; //只查浙江
        @Prop({ default: () => false }) onlyView!: Boolean; //是否只显示文本不编辑，默认为编辑状态
        distinctareaApi:DistinctareaApi=new DistinctareaApi()
        @Model('on-change-default') defaultValue!: any

        eleId = this.NewGuid()
        isOpen = false
        top="initial"
        left="initial"
        right="initial"
        activeregionTab1="1"
        areaAllData:any=[]
        areaListData:any={
            // "1":{label:"国家",items:[]},
            "2":{label:"省/直辖市",defaultName:"省/直辖市",items:[]},
            "3":{label:"市",defaultName:"市",items:[]},
            // "4":{label:"区/县",defaultName:"区/县",items:[]},
            // "5":{label:"街道/镇",defaultName:"街道/镇",items:[]},
            // "6":{label:"村",defaultName:"村",items:[]},
        }
        selectData:any=[{value:1,text:"中国"},{value:0,text:""},{value:0,text:""},{value:0,text:""},{value:0,text:""},{value:0,text:""}]
        selectedValueText=""
        noChange=false // 是否执行赋值方法（用来解决赋值方法重复执行的问题）  false：执行   true：不执行
        contentIsEnter=false
        tempSelectedTxt=""    //组件内临时选择文本
        tempSelectedIds:any=[]    //组件内临时选择值
        loadApi=this.distinctareaApi
        @Watch("defaultValue")
        defaultValueChange(){
            if(!this.noChange){
                this.initValue()
            }
        }
        async mounted() {
            if(!this.isNull(this.actionApi)){
                this.loadApi=this.actionApi
            }
            this.$nextTick(()=>{
                let body:any = document.querySelector("body");
                if (body.append) {
                    body.append(this.$el.lastChild);
                } else {
                    body.appendChild(this.$el.lastChild);
                }
                $("#"+this.eleId).parents(".ivu-form-item-content").css("height","32px")
                $('body').mousedown((e)=>{
                    let id:any = $(e.target).parents("div[id*="+this.eleId+"]").attr("id")
                    if(!id){
                        this.isOpen = false
                    }
                });
            })
            await this.loadAreaList()
            await this.loadAreaListByPId()
            if(!this.isNull(this.defaultValue)){
                this.initValue()
            }
        }
        destroyed(){
            $("body").unbind("click");
        }
        initValue(){
            this.loadValue()
            setTimeout(() => {
                if(this.defaultValue.length>0){
                    this.defaultValue.forEach((item,index) => {
                        let itemInfo:any = this.Baselinq.from(this.areaAllData).firstOrDefault(item2 => item2["Id"]==item)
                        if(itemInfo){
                            this.loadAreaListByPId(index+2,item,itemInfo.Id>1?itemInfo.DistrcctName:"",true);
                        }
                    });
                }
            }, 50);

        }
        toggleRegion(isOpen){
            if(isOpen){
                let windowW = document.body.clientWidth
                let windowH = document.body.clientHeight
                let eleOffset:any = $("#"+this.eleId).offset()
                let elewidth:any = $("#"+this.eleId).width()
                let eleHeight:any = $("#"+this.eleId).height()
                if(windowW - eleOffset.left>=630){
                    this.left=eleOffset.left+"px"
                }else{
                    this.left=(eleOffset.left - 630 + elewidth)+"px"
                }
                if(windowH - eleOffset.top>=400){
                    this.top = (eleOffset.top+32)+"px"
                }else{
                    this.top = (eleOffset.top - 370)+"px"
                }
            }else{
                this.left="initial"
                this.right="initial"
            }
            this.isOpen=isOpen

        }
        async loadAreaListByPId(NodeLevel="2",PId="1",DistrcctName="",isAuto=false){
            if(DistrcctName!=""){
                this.selectData[parseInt(NodeLevel)-2].value=PId;
                this.selectData[parseInt(NodeLevel)-2].text=DistrcctName;
                this.areaListData[parseInt(NodeLevel)-1].label = DistrcctName
                for (const key in this.areaListData) {
                    if (key>=NodeLevel) {
                        this.areaListData[key].label = this.areaListData[key].defaultName
                        this.selectData[parseInt(key)-1].value = 0
                        this.selectData[parseInt(key)-1].text = ""
                    }
                }
                this.tempSelectedTxt=""
                this.tempSelectedIds=[]
                this.selectData.forEach((item,index) => {
                    if(item.text!=""){
                        this.tempSelectedTxt+=(index>0?"/":"")+item.text;
                        this.tempSelectedIds.push(item.value.toString())
                    }
                });
                if(!isAuto){
                    this.noChange = true
                }else{
                    this.selectedValueText = this.tempSelectedTxt
                }
            }
            const res: any = this.Baselinq.from(this.areaAllData).where(item2 => item2["PId"]==PId).toArray();
            this.areaListData[NodeLevel].items = res
            if(isAuto){
                this.activeregionTab1 = this.defaultValue.length.toString()
                return
            }
            if(res.length>0){
                this.activeregionTab1 = NodeLevel
            }
            setTimeout(() => {
                this.noChange = false
            }, 100);

        }
        async loadAreaList(){
            // if(this.zj){
            //     this.areaAllData = this.parseApiResult(await this.distinctareaApi.getZjDistinctArea())
            // }else{
            let res = await this.loadApi.getEntities();
            this.areaAllData = res.data;
            // }

        }
        loadValue(){
            this.noChange=true
            if(this.isNull(this.defaultValue)){
                this.$emit("on-change-default",[])
            }else if(typeof(this.defaultValue)=="number"){
                this.$emit("on-change-default",[this.defaultValue.toString()])
            }else if(typeof(this.defaultValue)!="object"){
                this.$emit("on-change-default",this.defaultValue.split(","))
            }
            setTimeout(() => {
                this.noChange = false
            }, 100);
        }
        getMaxZIndex() {
            var maxZ = Math.max.apply(null, $.map($('body *'), (e:any,n)=> {
                    if ($(e).css('position') != 'static') {
                        return parseInt($(e).css('z-index')) || -1;
                    }else{
                        return 0
                    }
                }
            ));
            return maxZ;
        }
        okBtnEvent(){
            this.$emit("on-change-default",this.tempSelectedIds)
            this.selectedValueText = this.tempSelectedTxt
            this.$emit("on-change",{value:this.tempSelectedIds,text:this.tempSelectedTxt})
            this.isOpen = false
        }
    }
